import { Component, HostListener, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MessageBusService } from 'src/app/services/message-bus.service';
import { MESSAGE_KEYS } from 'shared/constants';
import { PATHS } from 'shared/paths';
import { LANGUAGE } from '../../../../../shared/injection-tokens';
import { LABELS } from '../../../../../shared/labels';
import { Language } from '../../../../../shared/salesforce-types';

@Component({
    selector: 'top-navigation',
    templateUrl: './top-navigation.component.html',
    styleUrls: ['./top-navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TopNavigationComponent implements OnDestroy {
    isMenuOpen = false;
    isSearchOpen = false;
    paths: {
        diseases: string;
        resources: string;
        about: string;
        contactUs: string;
    };

    labels: (typeof LABELS)[Language.En];

    private sub = new Subscription();
    private messageBusService: MessageBusService;

    constructor(messageBusService: MessageBusService, @Inject(LANGUAGE) language: BehaviorSubject<Language>) {
        this.messageBusService = messageBusService;
        this.paths = {
            diseases: '/' + PATHS[language.value].diseases,
            resources: '/' + PATHS[language.value].resources,
            about: '/' + PATHS[language.value].about,
            contactUs: '/' + PATHS[language.value].contactUs,
        };
        this.labels = LABELS[language.value];

        this.sub.add(
            this.messageBusService.get(MESSAGE_KEYS.searchOpen).subscribe(isOpen => {
                this.isSearchOpen = !!isOpen;
            }),
        );
    }

    @HostListener('window:keydown.esc')
    closeSearch() {
        this.isSearchOpen = false;
        this.messageBusService.get(MESSAGE_KEYS.searchOpen).next(false);
        (document.activeElement as HTMLElement)?.blur();
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        this.isSearchOpen = false;
        this.messageBusService.get(MESSAGE_KEYS.searchOpen).next(false);
    }

    toggleSearch($event: MouseEvent) {
        $event.preventDefault();
        this.isSearchOpen = !this.isSearchOpen;
        this.messageBusService.get(MESSAGE_KEYS.searchOpen).next(this.isSearchOpen);
        this.isMenuOpen = false;
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
